import { Box, Group, Stack, Text, Title } from '@mantine/core';

import { Content, EXTRA_WIDE_CONTENT_WIDTH } from 'components/page/Content';
import { useCurrentTeam } from 'hooks/use-current-team';
import { useCurrentUser } from 'hooks/use-current-user';
import { useHeroMedia } from 'hooks/use-hero-media';

import { DashboardPlan } from './DashboardPlan';
import { DashboardUnread } from './DashboardUnread';

import cx from './Dashboard.module.scss';

const DashboardHero = () => {
    const user = useCurrentUser();
    const team = useCurrentTeam();
    const { image, video } = useHeroMedia();

    const firstName = user?.name?.split(' ')[0];

    return (
        <Box className={cx.hero}>
            {video ? (
                <video src={video.src} autoPlay loop muted playsInline style={{ pointerEvents: 'none' }} />
            ) : (
                <img src={image.src} alt="" />
            )}

            <Content width={EXTRA_WIDE_CONTENT_WIDTH}>
                <Group justify="space-between" align="center" gap="lg" py="xl">
                    <Stack gap="xs">
                        <Title order={1} c="white" fz={{ base: 32, md: 48 }} fw={800} lh={1.1}>
                            Welcome back{firstName && ', '}
                            {firstName && <span className="gradient-cyan-green">{firstName}</span>}
                        </Title>
                        {team && (
                            <Text fz="lg" c="gray.3">
                                Team: {team.name}
                            </Text>
                        )}
                        <DashboardUnread />
                    </Stack>
                    {team && <DashboardPlan team={team} />}
                </Group>
            </Content>
        </Box>
    );
};

export { DashboardHero };
